import React from 'react';
import { Button } from '../../components/ui/button';
import { Accordion, AccordionItem, AccordionTrigger, AccordionContent } from '../../components/ui/accordion';
import { Save } from 'lucide-react';
import { defaultServicesContent } from '../../siteContent';
import { useCms, Text, Lines } from './cmsShared';

const AdminContentServices = () => {
  const { content, update, save, saving } = useCms('services', defaultServicesContent);
  const c = content;

  return (
    <div>
      <div className="flex justify-between items-center mb-6">
        <div>
          <h2 className="font-heading text-xl font-bold text-[#003366]">Services Page — Content</h2>
          <p className="text-sm text-gray-500">Edit hero text, service cards, how-it-works steps and the closing CTA.</p>
        </div>
        <Button onClick={save} disabled={saving} data-testid="cms-services-save-btn" className="rounded-full bg-[#E74C3C] hover:bg-[#C0392B]">
          <Save className="w-4 h-4 mr-2" />{saving ? 'Saving…' : 'Save Changes'}
        </Button>
      </div>

      <Accordion type="multiple" defaultValue={['hero']} className="space-y-2">
        <AccordionItem value="hero" className="border rounded-xl px-4 bg-white">
          <AccordionTrigger>Hero Section</AccordionTrigger>
          <AccordionContent>
            <Text label="Heading" value={c.hero.heading} onChange={(v) => update(['hero', 'heading'], v)} />
            <Text label="Subtext" value={c.hero.subtext} onChange={(v) => update(['hero', 'subtext'], v)} area />
          </AccordionContent>
        </AccordionItem>

        <AccordionItem value="services-list" className="border rounded-xl px-4 bg-white">
          <AccordionTrigger>Service Cards ({(c.services || []).length})</AccordionTrigger>
          <AccordionContent>
            {(c.services || []).map((svc, i) => (
              <div key={i} className="border rounded-lg p-3 mb-4 bg-gray-50">
                <Text label={`Service ${i + 1} title`} value={svc.title} onChange={(v) => update(['services', i, 'title'], v)} />
                <Text label="Description" value={svc.description} onChange={(v) => update(['services', i, 'description'], v)} area />
                <Lines label="Features (one per line)" value={svc.features} onChange={(v) => update(['services', i, 'features'], v)} />
              </div>
            ))}
          </AccordionContent>
        </AccordionItem>

        <AccordionItem value="howitworks" className="border rounded-xl px-4 bg-white">
          <AccordionTrigger>How It Works Steps</AccordionTrigger>
          <AccordionContent>
            <Text label="Section heading" value={c.howItWorksHeading} onChange={(v) => update(['howItWorksHeading'], v)} />
            {(c.steps || []).map((step, i) => (
              <div key={i} className="border rounded-lg p-3 mb-3 bg-gray-50 grid grid-cols-2 gap-3">
                <Text label={`Step ${i + 1} title`} value={step.title} onChange={(v) => update(['steps', i, 'title'], v)} />
                <Text label="Description" value={step.desc} onChange={(v) => update(['steps', i, 'desc'], v)} />
              </div>
            ))}
          </AccordionContent>
        </AccordionItem>

        <AccordionItem value="cta" className="border rounded-xl px-4 bg-white">
          <AccordionTrigger>Closing CTA</AccordionTrigger>
          <AccordionContent>
            <Text label="Heading" value={c.cta.heading} onChange={(v) => update(['cta', 'heading'], v)} />
            <Text label="Subtext" value={c.cta.subtext} onChange={(v) => update(['cta', 'subtext'], v)} area />
            <Text label="Button label" value={c.cta.button} onChange={(v) => update(['cta', 'button'], v)} />
          </AccordionContent>
        </AccordionItem>
      </Accordion>

      <div className="flex justify-end mt-6">
        <Button onClick={save} disabled={saving} className="rounded-full bg-[#E74C3C] hover:bg-[#C0392B]">
          <Save className="w-4 h-4 mr-2" />{saving ? 'Saving…' : 'Save Changes'}
        </Button>
      </div>
    </div>
  );
};

export default AdminContentServices;
